var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheckered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 4.5V12H3.83156C3.77699 11.5019 3.74976 11.0011 3.75 10.5V5.25C3.75 5.05109 3.82902 4.86032 3.96967 4.71967C4.11032 4.57902 4.30109 4.5 4.5 4.5H12ZM12 12V21.75C12 21.75 19.3181 19.7531 20.1684 12H12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C4.10218 3.75 3.72064 3.90804 3.43934 4.18934C3.15804 4.47064 3 4.85218 3 5.25V10.5C3 15.4425 5.3925 18.4378 7.39969 20.0803C9.56156 21.8484 11.7122 22.4494 11.8059 22.4738C11.9348 22.5088 12.0708 22.5088 12.1997 22.4738C12.2934 22.4494 14.4413 21.8484 16.6059 20.0803C18.6075 18.4378 21 15.4425 21 10.5V5.25C21 4.85218 20.842 4.47064 20.5607 4.18934C20.2794 3.90804 19.8978 3.75 19.5 3.75ZM11.25 20.6766C10.2068 20.228 9.2309 19.6367 8.35031 18.9197C6.3675 17.2978 5.14406 15.2288 4.69406 12.75H11.25V20.6766ZM11.25 11.25H4.52156C4.5075 11.0034 4.5 10.7541 4.5 10.5V5.25H11.25V11.25ZM15.6937 18.8831C14.8014 19.6154 13.8104 20.2185 12.75 20.6747V12.75H19.3041C18.8588 15.21 17.6503 17.2669 15.6937 18.8831ZM19.5 10.5C19.5 10.7541 19.4925 11.0034 19.4784 11.25H12.75V5.25H19.5V10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckered);
export default __webpack_public_path__ + "static/media/ShieldCheckered.a932289580a3c82515b315d46f7b53ed.svg";
export { ForwardRef as ReactComponent };